import(/* webpackMode: "eager" */ "/codebuild/output/src1495867874/src/apps/wrap.gifts/node_modules/next/dist/client/link.js");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/codebuild/output/src1495867874/src/apps/wrap.gifts/src/app/home/EcardsNarrativeBanner.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/codebuild/output/src1495867874/src/apps/wrap.gifts/src/app/home/HomePageModal.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/codebuild/output/src1495867874/src/apps/wrap.gifts/src/app/home/SearchBar.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/codebuild/output/src1495867874/src/apps/wrap.gifts/src/app/home/TemplateList.tsx");
